<template>
  <account-modal class="debt-write-off-modal">
    <template slot="heading">
      <template>Write-off debt from wallet {{ account.accountId }}</template>
    </template>

    <template slot="content">
      <error-alert
        :error="error"
        class="mb-4"
      />

      <p>In order to write-off debt from wallet it must meet the following requirements:</p>

      <div class="mb-4">
        <v-checkbox
          label="Profile must be blocked or closure"
          :input-value="isProfileBlocked"
          :ripple="false"
          readonly
          hide-details
          color="red"
          class="debt-write-off-modal__requirement mb-2"
        />
        <v-checkbox
          label="Wallet must have negative balance in EUR"
          :input-value="hasNegativeBalanceInEur"
          :ripple="false"
          readonly
          hide-details
          color="red"
          class="debt-write-off-modal__requirement mb-2"
        />
        <v-checkbox
          label="Wallet must have zero balance in foreign currencies"
          :input-value="hasZeroBalanceInOtherCurrencies"
          :ripple="false"
          readonly
          hide-details
          color="red"
          class="debt-write-off-modal__requirement"
        />
      </div>

      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <div class="headline">Summary</div>
        </v-flex>
      </v-layout>

      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">Wallet</v-subheader>
        </v-flex>
        <v-flex xs8>
          <span class="subheading">{{ account.accountId }}</span>
        </v-flex>
      </v-layout>

      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">Profile</v-subheader>
        </v-flex>
        <v-flex xs8>
          <span class="subheading">{{ profile.name }}</span>
        </v-flex>
      </v-layout>

      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense">Payment details</v-subheader>
        </v-flex>
        <v-flex xs8>
          <span class="subheading">Customer debt write-off</span>
        </v-flex>
      </v-layout>

      <div class="layout row">
        <div class="flex xs4" />
        <div class="flex xs8">
          <hr class="grey lighten-3 v-divider theme--light">
        </div>
      </div>

      <v-layout
        class="row--data"
        row
      >
        <v-flex xs4>
          <v-subheader class="v-subheader--dense font-weight-medium black--text">Amount</v-subheader>
        </v-flex>
        <v-flex xs8>
          <span class="subheading font-weight-medium">{{ writeOffBalance.balance | number }} {{ writeOffBalance.currency }}</span>
        </v-flex>
      </v-layout>
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        :disabled="!canWriteOffDebt || loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'

  // Component
  import ErrorAlert from '@/components/ui/ErrorAlert'
  import AccountModal from '@/components/accounts/AccountModal'

  export default {
    name: 'DebtWriteOffModal',
    components: {
      ErrorAlert,
      AccountModal
    },
    data () {
      return {
        accountDebtWriteOffApiRequest: new ApiRequest(AccountApi.debtWriteOff)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profile () {
        return this.modal.data.profile
      },
      account () {
        return this.modal.data.account
      },
      loading () {
        return this.accountDebtWriteOffApiRequest.loading
      },
      error () {
        return this.accountDebtWriteOffApiRequest.error
      },
      writeOffBalance () {
        return this.account.balances.find(accountBalance => accountBalance.currency === 'EUR')
      },
      hasZeroBalanceInOtherCurrencies () {
        return this.account.balances
          .filter(accountBalance => accountBalance.currency !== 'EUR')
          .every(accountBalance => accountBalance.balance === 0)
      },
      hasNegativeBalanceInEur () {
        return this.writeOffBalance.balance < 0
      },
      isProfileBlocked () {
        return this.profile.isBlocked || this.profile.isClosed
      },
      canWriteOffDebt () {
        return this.hasZeroBalanceInOtherCurrencies && this.hasNegativeBalanceInEur && this.isProfileBlocked
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.accountDebtWriteOffApiRequest
          .execute(this.account.accountId)
          .then(this.accountDebtWriteOffSuccessHandler)
          .catch(() => {}) // Error handled in computed prop
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      accountDebtWriteOffSuccessHandler () {
        this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profile.id)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Wallet debt has been successfully written off.' }
          })
        }, 100)
      }
    }
  }
</script>

<style lang="scss">
  .debt-write-off-modal {
    &__requirement {
      .v-input__control {
        input,
        label {
          cursor: default;
        }
      }
    }
  }
</style>
